"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("events");
const uuidv4 = require("uuid");
class Closeable extends events_1.EventEmitter {
    constructor() {
        super();
        this.closed = false;
        this.uuid = uuidv4();
    }
    get listenerUuid() {
        return this.uuid;
    }
    close() {
        this.removeAllListeners();
        this.closed = true;
    }
    ensureNotClosed() {
        if (this.closed) {
            throw new Error('Invalid operation on closed object');
        }
    }
}
exports.Closeable = Closeable;
exports.default = Closeable;
